module.exports = __webpack_public_path__ + "css/OceanVolt.8d74abae.css";